import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import useThemeContext from "../../../hooks/useThemeSwitch";
import { setRootContainerWidth } from "../../../reducers/layout/layoutReducer";
import ValetRequestMonitor from "../../../components/ValetRequestMonitor/ValetRequestMonitor";
import { Dialog, DialogContent } from "@material-ui/core";

const RequestMonitorPage = (props) => {
  const { layoutReducer } = useThemeContext();
  const [, layoutDispatch] = layoutReducer;
  const location = useLocation();
  const [dialogOpen, setDialogOpen] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const poppedOut = queryParams.get("poppedOut") === "true";

    if (poppedOut) {
      setDialogOpen(true);
    } else {
      layoutDispatch({ type: setRootContainerWidth, payload: false });
    }
  }, [location.search, layoutDispatch]);

  return (
    <>
      {dialogOpen ? (
        <Dialog fullScreen open={dialogOpen}>
          <DialogContent>
            <ValetRequestMonitor />
          </DialogContent>
        </Dialog>
      ) : (
        <ValetRequestMonitor />
      )}
    </>
  );
};

export default RequestMonitorPage;
